import { render, staticRenderFns } from "./NowVsFutureTableAB.vue?vue&type=template&id=7b99d2ca&scoped=true"
import script from "./NowVsFutureTableAB.vue?vue&type=script&lang=js"
export * from "./NowVsFutureTableAB.vue?vue&type=script&lang=js"
import style0 from "./NowVsFutureTableAB.vue?vue&type=style&index=0&id=7b99d2ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b99d2ca",
  null
  
)

export default component.exports